import { useCallback } from 'react'
import _ from 'lodash'
import { WarehouseType } from 'utils/types'

type OptionsType = {
  value: number
}

type FetchCustomBerthLabelParams = {
  tenantId?: number
  hasTenant?: boolean
}

type UseReceptionCustomHeaderParams = {
  warehouses: WarehouseType[]
  changeWarehouse: (warehouseId: number) => void
  changeTenant: (tenantId: number) => void
  fetchReceptionParameters: (tabMode: string) => void
  fetchCustomBerthLabel: (params?: FetchCustomBerthLabelParams) => void
  tabMode: string
}

/**
 * ReceptionCustom の Header（倉庫・テナント選択）用のハンドラーを提供するフック
 */
export const useReceptionCustomHeader = ({
  warehouses,
  changeWarehouse,
  changeTenant,
  fetchReceptionParameters,
  fetchCustomBerthLabel,
  tabMode,
}: UseReceptionCustomHeaderParams) => {
  const onChangeWarehouse = useCallback(
    ({ value: warehouseId }: OptionsType) => {
      const selectedWarehouse = warehouses.find((warehouse) => warehouse.id === warehouseId)
      const tenantId = _.first(selectedWarehouse?.tenants)?.id

      changeWarehouse(warehouseId)
      tenantId && changeTenant(tenantId)
      fetchReceptionParameters(tabMode)
      fetchCustomBerthLabel({ tenantId })
    },
    [warehouses, changeWarehouse, changeTenant, fetchReceptionParameters, fetchCustomBerthLabel, tabMode]
  )

  const onChangeTenant = useCallback(
    ({ value: tenantId }: OptionsType) => {
      changeTenant(tenantId)
      fetchReceptionParameters(tabMode)
      fetchCustomBerthLabel({ tenantId })
    },
    [changeTenant, fetchReceptionParameters, fetchCustomBerthLabel, tabMode]
  )

  return {
    onChangeWarehouse,
    onChangeTenant,
  }
}
